<script setup lang="ts">
const route = useRoute()
const router = useRouter()

const tabs = [
    { value: 'push', label: 'Push-Benachrichtigungen', icon: 'mdi-bell' },
    { value: 'hortpro', label: 'HortPro-Verbindung', icon: 'mdi-link-variant' }
]

// Sync tab with URL hash
const activeTab = ref('push')

watch(
    () => route.hash,
    (newHash) => {
        if (newHash) {
            const tabValue = newHash.replace('#', '')
            if (tabs.some(t => t.value === tabValue)) {
                activeTab.value = tabValue
            }
        }
    },
    { immediate: true }
)

watch(activeTab, (newTab) => {
    router.replace({ hash: `#${newTab}` })
})
</script>

<template>
    <v-container fluid class="pa-0">
        <!-- Header -->
        <div class="mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">Einstellungen</h1>
            <p class="text-body-1 text-medium-emphasis">
                Verwalte deine Push-Benachrichtigungen und HortPro-Verbindung
            </p>
        </div>

        <!-- Tabs -->
        <v-card>
            <v-tabs
                v-model="activeTab"
                bg-color="primary"
                color="white"
                grow
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.value"
                    :value="tab.value"
                >
                    <v-icon start>{{ tab.icon }}</v-icon>
                    {{ tab.label }}
                </v-tab>
            </v-tabs>

            <v-divider></v-divider>

            <v-window v-model="activeTab">
                <!-- Push Benachrichtigungen Tab -->
                <v-window-item value="push">
                    <v-container class="pa-6">
                        <push-settings />
                        <notification-preferences />
                    </v-container>
                </v-window-item>

                <!-- HortPro Verbindung Tab -->
                <v-window-item value="hortpro">
                    <v-container class="pa-6">
                        <hort-pro-credentials-form />
                    </v-container>
                </v-window-item>
            </v-window>
        </v-card>
    </v-container>
</template>

<style scoped>
</style>
